const SavedReports = () => import(/* webpackChunkName: "saved-reports" */ '@/pages/savedReports/SaveReportsIndex')
const ReportsIndex = () => import(/* webpackChunkName: "saved-report" */ '@/pages/reports/ReportsIndex')
const ReportStandardsOverview = () => import(/* webpackChunkName: "saved-report" */ '@/pages/reports/standardsOverviewReport/StandardsOverviewReport.vue')
const SavedReportIndex = () => import(/* webpackChunkName: "saved-report" */ '@/pages/savedReports/singleReport/ReportIndex')
const SingleReport = () => import(/* webpackChunkName: "saved-report" */ '@/pages/savedReports/singleReport/SingleReport')
const ShareReport = () => import(/* webpackChunkName: "saved-report" */ '@/pages/savedReports/singleReport/ShareReport')
const CreateAndShareReport = () => import(/* webpackChunkName: "browse" */ '@/pages/reports/ShareReport.vue')

export default [
  // Reports
  {
    path: '/develop/reports',
    name: 'Reports',
    component: ReportsIndex,
    redirect: { name: 'ReportStandardsOverview' },
    children: [
      {
        path: 'standards-overview',
        name: 'ReportStandardsOverview',
        component: ReportStandardsOverview,
        children: [
          {
            path: 'share',
            name: 'StandardsOverviewShareReport',
            component: CreateAndShareReport
          }
        ]
      }
    ]
  },
  // Saved Reports
  {
    path: '/develop/saved-reports',
    name: 'SavedReports',
    component: SavedReports
  },
  {
    path: '/develop/saved-reports/:id',
    name: 'SavedReport',
    component: SavedReportIndex,
    redirect: { name: 'SingleReport' },
    children: [
      {
        path: '',
        name: 'SingleReport',
        component: SingleReport
      },
      {
        path: 'share',
        name: 'ShareReport',
        component: ShareReport
      }
    ]
  }
]
